import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { ICommonImageProps } from "@adgm/cross-models";

interface ImageProps extends Pick<ICommonImageProps, "width" | "height" | "alt"> {
  source: string | StaticImport;
  style?: React.CSSProperties;
}

export const CommonImage = (props: ImageProps) => {
  const { source, alt, width, height } = props;
  return <Image src={source} alt={alt || ""} width={width} height={height} style={props.style} />;
};
